import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { firebase as fb, helpers } from 'redux-firebasev3';
import { Link } from 'react-router';

import { teamMetaPath } from '../../utils/firebasePaths';
import teamIdFromAuth from '../../enhancers/teamIdFromAuth';

const { dataToJS } = helpers;

@teamIdFromAuth({ hideOnUnauthenticated: true })
@fb(({ teamId }) => [
  `${teamMetaPath(teamId)}/name`,
  `${teamMetaPath(teamId)}/image`,
])
@connect(
  ({ firebase }, { teamId }) => ({
    name: dataToJS(firebase, `${teamMetaPath(teamId)}/name`),
    image: dataToJS(firebase, `${teamMetaPath(teamId)}/image`),
  })
)
export default class TeamHeader extends Component {
  static propTypes = {
    children: PropTypes.node,
    image: PropTypes.string,
    name: PropTypes.string,
    teamId: PropTypes.string.isRequired,
  }

  render() {
    const {
      image,
      name,
    } = this.props;

    return (
      <div className="dtc">
        <Link className="navy no-underline" to="/dashboard">
          <div className="mt0 navy dt center">
            <div className="dtc">
              {image &&
                <img
                  alt="Team"
                  className="br2"
                  height="27px"
                  src={image}
                  width="27px"
                />
              }
            </div>
            <div className="dn dtc-ns v-mid pl1 f5">
              { name }
            </div>
          </div>
        </Link>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/TeamHeader/index.jsx
 **/